import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.use(VueI18n)

const numberFormats = {
  'sv-SE': {
    currency: {
      style: 'currency',
      currency: 'SEK'
    }
  }
}

export var i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  numberFormats,
  silentTranslationWarn: true
})

var loadedLanguages = [] // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync(lang) {
  if (loadedLanguages.includes(lang)) {
    if (i18n.locale !== lang) setI18nLanguage(lang)
    return Promise.resolve()
  }
  return axios
    .get(`${process.env.VUE_APP_TRANSLATION_URL}/${lang}.json`)
    .then(response => {
      let msgs = response.data
      loadedLanguages.push(lang)
      i18n.setLocaleMessage(lang, msgs)
      setI18nLanguage(lang)
    })
}
